import { version } from './version.js';
export const getContractAddress = (address) => address;
export const getUrl = (url) => url;
export const getVersion = () => `viem@${version}`;
//# sourceMappingURL=utils.js.map